import { RESET_STORE, STORE, WhitelistAction } from '../global';
import { checkWhitelist } from '../reducer-utils';
import {
  SCROLL_TO,
  TRIP_TRAVELLER_TYPE,
  TravellerSelection,
  ScrollActionPayload,
  SET_ACCORDION_OPEN,
  CLEAR_ACCORDION_OPEN,
  TRAVELLER_FORM_ERRORS,
  TRAVELLER_PAYMENT,
  TravellerJourneyPayload,
  TRAVELLER_JOURNEY_SELECTION,
  ACCEPT_LEGAL,
  SELECT_PLAN_PAGE_FOCUS,
  COVERME_TRIP_TRAVELLER_TYPE
} from './types';

const initialState = {
  individualPayment: 'false',
  legalConsent: false
};

const cases: Record<
  string,
  (
    state: TravellerSelection,
    action: {
      type: string;
      payload?: unknown;
    }
  ) => TravellerSelection
> = {
  [ACCEPT_LEGAL]: (state, action) => {
    const act = action.payload as boolean;
    return { ...state, legalConsent: act };
  },
  [SET_ACCORDION_OPEN]: (state, action) => {
    const act = action.payload as number;
    const nextState = state.openAccordion && state.openAccordion[act] ? false : true;
    return { ...state, openAccordion: { ...state.openAccordion, [act]: nextState } };
  },
  [CLEAR_ACCORDION_OPEN]: state => ({ ...state, openAccordion: undefined }),
  [TRAVELLER_FORM_ERRORS]: (state, action) => ({ ...state, showPageError: action.payload as boolean }),
  [SCROLL_TO]: (state, action) => {
    const act = action.payload as ScrollActionPayload;
    return { ...state, ...act };
  },
  [TRIP_TRAVELLER_TYPE]: (state, action) => {
    const act = action.payload as ScrollActionPayload;
    return { ...state, ...act };
  },
  [COVERME_TRIP_TRAVELLER_TYPE]: (state, action) => {
    const act = action.payload as TravellerSelection;
    return { ...state, isFamily: act.isFamily };
  },
  [TRAVELLER_PAYMENT]: (state, action) => ({ ...state, individualPayment: action.payload as string }),
  [TRAVELLER_JOURNEY_SELECTION]: (state, action) => ({ ...state, ...(action.payload as TravellerJourneyPayload) }),
  [RESET_STORE]: (state, action) => {
    const { whitelist } = (action.payload ?? {}) as WhitelistAction;
    return checkWhitelist(whitelist, STORE.TRAVELLER_SELECTION, state, initialState);
  },
  [SELECT_PLAN_PAGE_FOCUS]: (state, action) => ({ ...state, selectPlanPageFocus: action.payload as string })
};

export const travellerSelection = (
  state: TravellerSelection = {
    individualPayment: 'false',
    legalConsent: false
  },
  action: {
    type: string;
    payload?: unknown;
  }
): TravellerSelection => {
  const reducer = cases[action.type];
  return reducer ? reducer(state, action) : state;
};
